import { checkLoginUrl, loginOut } from '@/api/api'
import city from '@/utils/city'
export default {
  install(Vue, options) {
    Vue.prototype.$checkLogin = function (userInfo) {
      // console.log(userInfo)
      if (!userInfo) {
        return Promise.reject();
      } else {
        let url = checkLoginUrl;
        let data = { access_token: userInfo.access_token };
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        return this.$axios({
          method: "post",
          data: param,
          url
        })
          .then(res => {
            console.log('checkeLogin')
            console.log(res)
            if (res.data.resultCode == 1) {
              return Promise.resolve();
            } else {
              return Promise.reject();
            }
          })
         .catch((err) => {
            return Promise.reject();
          });
      }
    }
    Vue.prototype.$getCartInfo = function (cartList) {
      let num = 0
      let totalMoney = 0
      let data = []
      if (cartList) {
        cartList.forEach((item) => {
          let storeMoney = 0
          let storeId = ''
          item.forEach((item2) => {
            if (item2.cart_checked) {
              totalMoney += (item2.cart_num * item2.price)
              num += item2.cart_num
              storeMoney+=(item2.cart_num * item2.price)
              storeId = item2.storeId
            }
          })

          data.push({storeMoney,storeId})
        })
      } else {
        num = 0;
        totalMoney = 0;
        return { num, totalMoney,data:null}
      }
     return  { num, totalMoney,data}
    }
    Vue.prototype.$loginOut = function (userInfo) {
      // console.log(userInfo)
      let url = loginOut;
      let data = { access_token: userInfo.access_token };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      return this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          if (res.data.resultCode == 1) {
            return Promise.resolve();
          } else {
            return Promise.resolve();
          }
        }).catch((err) => {
          return Promise.resolve();
        });
    }
    Vue.prototype.$getAreaInfo = function (areaId) {
      let sheng = ''
      let shi = ''
      let qu = ''

      let shengCode = String(areaId).substr(0, 2) + '0000'
      let shiCode = String(areaId).substr(0, 4) + '00'
      let quCode = String(areaId)
      // console.log(shengCode,shiCode,quCode)
      city.forEach((item) => {
        if (item.value == shengCode) {
          sheng = item.label
          item.children.forEach((item2) => {
            if (item2.value = shiCode) {
              shi = item2.label
              item2.children.forEach((item3) => {
                if (item3.value == quCode) {
                  qu = item3.label
                }
              })
            }

          })
        }
      })
      let  arr = []
      arr.push(sheng)
      arr.push(shi)
      arr.push(qu)
      return arr
    }
    Vue.prototype.$filterCheckedCartInfo = function (cartList) {
      let newArr = []
      if (cartList) {
        cartList.forEach((item) => {
          let arrItem = []
         item.forEach((item2) => {
          if(item2.cart_checked){
            arrItem.push(item2)
          }
          })
          newArr.push(arrItem)
        })
      }else{
        newArr=null
      }

      if(newArr){
        newArr= newArr.filter((item) => {
         return  item.length!=0
        })
      }
      

      return newArr
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/plugin/global.js